import React, { FunctionComponent, useEffect, useRef } from "react";

import { bridge } from "@multiweb/reactCore/bridge";
import { UNKNOWN_KEY_TEXT } from "@multiweb/reactCore/i18n";
import { createQA } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { RowActionProps } from "../RowAction";

const { executeReactConnectorAction } = bridge;

export type RowActionComponentProps = RowActionProps & {
    /** Ikona k zobrazení. */
    iconCode?: IconCode;
    /** Určuje viditelnost akce. */
    visible?: boolean;
    /** Lokalizovaný název akce. */
    actionText?: string;
    /** Lokalizovaný popis akce. */
    actionTitle?: string;
    /** Určuje, zda je komponenta vizuálně aktivní a zda s ní lze pracovat. */
    interactive?: boolean;
    /** Pošle info o své velikosti */
    onSizeCallback?: (id: string, size: number) => void;
};

export const RowActionComponent: FunctionComponent<RowActionComponentProps> = ({
    iconCode,
    visible = true,
    actionText = UNKNOWN_KEY_TEXT,
    actionTitle,
    interactive = true,
    disabled,
    actionId,
    recordId,
    onSizeCallback,
    dataSourceKey,
}) => {
    const targetRef = useRef(null);

    useEffect(() => {
        if (targetRef.current && onSizeCallback) {
            onSizeCallback(actionId, (targetRef.current as unknown as HTMLButtonElement).clientWidth);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionText]);

    return (
        <button
            className={`btn btn-large flat${iconCode ? " icon no-caption " + iconCode : ""}${
                interactive && !disabled ? "" : " Disabled"
            } ${!visible ? " row-action-component--hidden" : ""}`}
            aria-label={actionText}
            title={actionTitle}
            onClick={(event) => {
                if ((event.target as HTMLButtonElement).classList.contains("Disabled")) {
                    return;
                }
                executeReactConnectorAction(dataSourceKey, actionId, recordId);
                event.stopPropagation();
            }}
            {...createQA(actionText)}
            ref={targetRef}
        >
            <span className={`btn-caption${interactive && !disabled ? "" : " Disabled"}`}>{actionText}</span>
        </button>
    );
};
